import calcApiFactory from './service/_calc-api';
import Validator from './directives/fb-errors/Validator.class';
import { mergeViewIece } from '@edicom/common/view/mergeViewIece/mergeViewIece';
import { mergeIncludes } from '@edicom/common/view/mergeIncludes/mergeIncludes';

ecFormBuilderService.$inject = ['ecNotificationsService', 'fbErrorsService', '$translate'];

export default function ecFormBuilderService(ecNotificationsService, fbErrorsService, $translate) {
  const cache = {
    locale: null,
  };
  translate();
  const calcApi = calcApiFactory(ecNotificationsService, flash);
  const service = {
    // funcción para juntar esquema de in4 con view parcial del repositorio antes de pasarlo al formBuilder
    merge: (...args) => {
      return mergeViewIece.apply(null, args);
    },

    mergeDependencies: (...args) => {
      return mergeIncludes.apply(null, args);
    },

    // grupo de funciones accesibles via el api de la directiva (para la instancia del form builder)
    fn,

    Validator: function(params) {
      // permite crear un objeto validador para pintar los errores.
      if (!cache.runValidate) {
        cache.runValidate = fbErrorsService.validate(getWorkerUrl());
      }
      params.runValidate = cache.runValidate;
      return new Validator(params);
    },

    translate,
  };

  return service;

  //////////////////////////////////////////////////////////////////////////////

  function getWorkerUrl() {
    const WEB_WORKER_FILENAME = 'ec-form-builder-edicom.worker.js';
    const WEB_WORKER_URL_ATTRIBUTE = 'ec-form-builder-edicom-worker-url';
    // documnent.currentScript solo funciona al principio de la ejecución del script
    const el = document.querySelector(`[${WEB_WORKER_URL_ATTRIBUTE}]`);
    if (el) {
      const url = el.getAttribute(WEB_WORKER_URL_ATTRIBUTE);
      return url;
    }
    // sino, lo construimos a partir de la base de este
    const src = window.edicom['@edicom/ec-form-builder-edicom'].src;
    return src.replace(/\/([^\/]*)$/, `/${WEB_WORKER_FILENAME}`);
  }

  function fn($scope, registerName) {
    const getValueFromScope = getValueFromScopeFactory($scope);
    const setValueToScope = setValueToScopeFactory($scope);
    const evalFn = evalFactory($scope, registerName);
    const evalPromise = evalPromiseFactory($scope, registerName);
    return {
      eval: evalFn,
      evalPromise,
      // watch             : watchFactory($scope, unbinders),
      getValueFromScope,
      setValueToScope,
    };
  }

  function evalFactory($scope, registerName) {
    return function execScript(script, params) {
      // ejecuta un script (en String), dando acceso al "CAB" y "api" de calcApiService
      // se puede pasar parametros en objeto: {<nombre_variable> : <valor>, ...}
      // ej. llamada eval('console.log("es mi script " + name);', {name: 'mi super script'})
      // return err (o false si OK)
      if (typeof params !== 'object') {
        params = {};
      }

      script = `
      return (function(${Object.keys(params)}){
        try{; ${script}; \n }
        catch(e){
          console.error("eval",e);
          return e
        }
        return false;
      }).apply(null, this)
      `;
      return new Function(registerName, 'api', script).call(Object.values(params), $scope[registerName], calcApi);
    };
  }

  function evalPromiseFactory($scope, registerName) {
    return function execPromise(script, params) {
      // ejecuta un script (en String), dando acceso al "CAB" y "api" de calcApiService
      // se puede pasar parametros en objeto: {<nombre_variable> : <valor>, ...}
      // ej. llamada eval('console.log("es mi script " + name);', {name: 'mi super script'})
      // return err (o false si OK)
      if (typeof params !== 'object') {
        params = {};
      }

      const fnBody = `
      return (function(${Object.keys(params)}){
        try{
          return Promise.resolve()
            .then(() => {
              ${script};
            });
        } catch(e){
          console.error("eval",e);
          return e
        }
        return false;
      }).apply(null, this)
      `;
      return new Function(registerName, 'api', fnBody).call(Object.values(params), $scope[registerName], calcApi);
    };
  }

  // function watchFactory($scope, unbinders) {
  //   return function watch(expression, fn) {
  //     unbinders.push($scope.$watch(expression, fn));
  //   };
  // }

  function getValueFromScopeFactory(scope) {
    return function getValueFromScope(model) {
      return model.split('.').reduce((acc, cur) => {
        if (!acc[cur]) {
          return '';
        }
        return acc[cur];
      }, scope);
    };
  }

  function setValueToScopeFactory(scope) {
    return function setValueToScope(model, value, callback) {
      // eval('$scope.'+model+'='+JSON.stringify(value))
      const m = model.split('.');
      let len = m.length;
      m.reduce((pre, cur) => {
        len--;
        if (!len) {
          pre[cur] = value;
          return;
        }
        if (!pre[cur]) {
          pre[cur] = {};
        }
        return pre[cur];
      }, scope);
      callback && callback(model, value);
    };
  }

  function translate() {
    if (cache.locale) {
      return cache.locale;
    }

    cache.locale = $translate(['fbTree.create', 'fbTree.add', 'fbTree.insert', 'fbTree.clone', 'fbTree.remove', 'fbTree.empty', 'fbTree.selectOneNode']);
    return cache.locale;
  }

  function flash({ section = '', model = '', indexes = '' }) {
    const elem = document.querySelector('ec-form-builder');
    elem.flash({ section, model, indexes: indexes.split(',') });
  }
} // fin controller
